import { render, staticRenderFns } from "./PrevisaoGatilho.vue?vue&type=template&id=47f6a024&scoped=true"
import script from "./PrevisaoGatilho.vue?vue&type=script&lang=js"
export * from "./PrevisaoGatilho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6a024",
  null
  
)

export default component.exports